export default __webpack_public_path__ + "static/media/smiley-01.8ff54087.png";